export default __webpack_public_path__ + "static/media/americaExpress.5cfca319.png";